var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[(_vm.next_item)?_c('router-link',{attrs:{"to":'/project/' + _vm.next_item.url_title}},[_c('p',[_vm._v("next")]),_c('p',{staticClass:"nextTitle"},[_vm._v(_vm._s(_vm.next_item.title))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }